import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { mergeBridgeServerQueueSnapshot, readPersistedQueue, writePersistedQueue } from '../disk-store.js';
import { syncRunningTurnQueueKeys } from './run-id-queue-key-map.js';
import type { PromptQueueSnapshotEntries } from './prompt-queue-snapshot-types.js';

export async function persistPromptQueueSnapshot(entries: PromptQueueSnapshotEntries): Promise<void> {
  for (const [queueKey, serverTurns] of entries) {
    const file = await mergeBridgeServerQueueSnapshot(queueKey, serverTurns);
    await writePersistedQueue(file);
    await yieldToEventLoop();
  }
  for (const [queueKey] of entries) {
    const file = await readPersistedQueue(queueKey);
    if (file) syncRunningTurnQueueKeys(file.turns, queueKey);
    await yieldToEventLoop();
  }
}
